var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 7.96289H11.25V4.96289C11.25 3.72239 10.2405 2.71289 9 2.71289C7.7595 2.71289 6.75 3.72239 6.75 4.96289V7.96289H5.25V4.96289C5.25 2.89514 6.93225 1.21289 9 1.21289C11.0677 1.21289 12.75 2.89514 12.75 4.96289V7.96289Z",
    fill: "#FFE5B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 7.21289H3.75C2.5095 7.21289 1.5 8.22239 1.5 9.46289V15.4629C1.5 16.7034 2.5095 17.7129 3.75 17.7129H14.25C15.4905 17.7129 16.5 16.7034 16.5 15.4629V9.46289C16.5 8.22239 15.4905 7.21289 14.25 7.21289ZM9.75 13.0044V14.7129H8.25V13.0044C7.80375 12.7441 7.5 12.2656 7.5 11.7129C7.5 10.8856 8.17275 10.2129 9 10.2129C9.82725 10.2129 10.5 10.8856 10.5 11.7129C10.5 12.2656 10.1962 12.7441 9.75 13.0044Z",
    fill: "#FFE5B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon-lock.7353ebfe5ccb9dfbe8c5f3b72848b037.svg";
export { ForwardRef as ReactComponent };